
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';
import {Routes, Route } from 'react-router-dom';

// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

import Navbar from './views/navBar';
import Footer from './views/footer';
import routes from './routes/routes';
// import Home from './views/home';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div >
        <Navbar/>
      </div>
      s
      {/* <div>
        <Home/>
      </div> */}
      

      {/* Page Content */}
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>

      {/* Full-Width Footer */}
     
        <Footer />
      
      </ThemeProvider>
  );
}

export default App;
